export const INNER_BORDER_WIDTH = 3;
